export default "__VITE_ASSET__ebc1a5d9__"